export const FILTER_COLUMNS = {
  PUBLISH_STATUS: "PublishStatus",
  PUBLISH_STATUS_MS: "publishStatus",
  ACTIVE_PROGRAMS: "ActiveProgramsIds",
  ACTIVE_PROGRAM_TYPE: "activeProgramType",
};

export const FILTER_COLUMNS_TEXT = {
  PUBLISH_STATUS: "Status",
  ACTIVE_PROGRAM_TYPE: "Active Program Type",
  ACTIVE_PROGRAMS: "Access Programs",
};
